import styles from './reviewModal.less';
import Form, {FormSubmitOptions} from './reviewModal/form';
import Status from './reviewModal/status';
import {SizeRatingSize} from './reviewModal/form/sizeRating';

export {styles};

enum ReviewModalStep {
    FORM,
    STATUS,
}

export interface ProductProps {
    id: number;
    name: string;
    image: string;
}

export interface CustomerProps {
    nickname: string;
}

export interface ImageOptions {
    maxFileSize: number;
    maxWidth: number;
    quality: number;
}

export interface ShowOptions {
    submitUrl: string;
    customer: CustomerProps;
}

interface ReviewModalProps {
    product: ProductProps;
    sizeRating: boolean;
    sizes: SizeRatingSize[];
    imageOptions: ImageOptions;
}

interface ReviewModalState {
    step: ReviewModalStep;
    visible: boolean;
    loading: boolean;
    submitUrl?: string;
    customer?: CustomerProps;
}

export default class ReviewModal extends React.Component<ReviewModalProps, ReviewModalState> {

    private _formRef = React.createRef<Form>();

    constructor(props) {
        super(props);

        this.state = {
            step: ReviewModalStep.FORM,
            visible: false,
            loading: false,
        };

        this.onClickClose = this.onClickClose.bind(this);
        this.onReviewSubmit = this.onReviewSubmit.bind(this);
    }

    show(options: ShowOptions) {
        this.setState({...this.state,
            visible: true,
            submitUrl: options.submitUrl,
            customer: options.customer,
        });
    }

    hide() {
        this.setState({...this.state,
            visible: false,
        });
    }

    onClickClose() {
        this.hide();
    }

    componentDidMount() {
        $j(document).on('keydown', (event) => {
            if (event.which == 27) { //escape
                this.hide();
            }
        });

        $j(document).on("dragover drop", (event) => {
            if (this.state.visible) {
                event.preventDefault();
            }
        });
    }

    onReviewSubmit(options: FormSubmitOptions) {
        this.setState({...this.state,
            step: ReviewModalStep.STATUS,
            loading: true,
        });

        $j.post(this.state.submitUrl, {
            productId: this.props.product.id,
            stars: options.stars,
            size: options.size,
            text: options.text,
            image: options.image,
            anonymous: Number(options.anonymous),
        }).done(() => {
            this.setState({...this.state,
                step: ReviewModalStep.STATUS,
                loading: false,
            });
        }).fail(() => {
            alert(_('Something went wrong, try again...'));

            this.setState({...this.state,
                step: ReviewModalStep.FORM,
                loading: false,
            });
        });
    }

    render() {
        $j('body').toggleClass(styles.disableScroll, this.state.visible);

        return (
            <>
                {this.state.visible && (
                    <div className={styles.wrapper}>
                        <div className={styles.overlay} onClick={this.onClickClose}/>
                        <div className={styles.modal}>
                            <div className={styles.head}>
                                <div className={styles.title}>
                                    {_('[REVIEW_MODAL] Write a review')}
                                </div>
                                <div className={styles.closeButton} onClick={this.onClickClose}>
                                    <i className="fa fa-times"/>
                                </div>
                            </div>

                            {this.state.step == ReviewModalStep.FORM && (
                                <Form
                                    ref={this._formRef}
                                    loading={this.state.loading}
                                    product={this.props.product}
                                    nickname={this.state.customer.nickname}
                                    sizeRating={this.props.sizeRating}
                                    sizes={this.props.sizes}
                                    imageOptions={this.props.imageOptions}
                                    onSubmit={this.onReviewSubmit}
                                />
                            )}

                            {this.state.step == ReviewModalStep.STATUS && (
                                <Status
                                    loading={this.state.loading}
                                />
                            )}
                        </div>
                    </div>
                )}
            </>
        );
    }
}
